import { render } from "./filter_vegan.svg?vue&type=template&id=55f625ac?inline"
const script = {}
script.render = render

export default script